// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__W_wXT","inputWrap":"CustomTip_inputWrap__QG-HU"};